import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip, Typography } from "antd";
import styles from "./common.module.scss";

const { Text } = Typography;

const ColumnHeader: React.FC<{ label: any; tooltip: any }> = ({
  label,
  tooltip,
}) => {
  return (
    <>
      <Text className={styles.columnLabel}>{label}</Text>
      <Tooltip title={tooltip}>
        <FontAwesomeIcon
          style={{ paddingLeft: "5px", fontSize: 12 }}
          icon={faCircleInfo}
          className={styles.cardIcon}
        />
      </Tooltip>
    </>
  );
};

export default ColumnHeader;
